import React from 'react';
import { useTranslation } from 'react-i18next';
import DividerWithText from '../../../../../../../../components/DividerWithText';
import RowResumeText from "../../../../../../../../components/RowResumeText";
import SummaryContainer from "../../../../../../Contractors/Components/SummaryContainer";
import RulesTable from "./RulesTable";
import CustomChip from "../../../../../../../../components/CustomChip";
import {colors} from "../../../../../../../../enums/colors";
import {getConflictResolutionById, getStackMethodById} from "../Model/Model";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
const PolicySummary = ({ item, isGlobal, departments }) => {
    const { t } = useTranslation();

    return (
        <>
            <DividerWithText title={t('details')} />
            <SummaryContainer>
                <div className="row">
                    <div className="col-12 pb-3 px-1">
                        <RowResumeText title={t('name')} value={item.name} />
                    </div>

                    {!isGlobal && departments.length > 0 && <>
                        <div className="col-sm-12 col-md-6 pb-3 px-1">
                            <RowResumeText title={t('departments')} value={ <div className='d-flex flex-wrap gap-2'>
                                {departments.map((dep) => (
                                    <CustomChip
                                        background={colors.secondary100}
                                        fontColor={colors.secondary700}
                                        borderColor={colors.secondary150}
                                        legend={dep?.label}
                                    />
                                ))}
                            </div>} />
                        </div>
                    </>
                    }

                    { item.conflictResolution &&
                        <div className="col-sm-12 col-md-6 pb-3 px-1">
                            <RowResumeText title={t('conflict_resolution')} value={getConflictResolutionById(item.conflictResolution)?.name} />
                        </div>
                    }

                    { item.stackMethod &&
                        <div className="col-sm-12 col-md-6 pb-3 px-1">
                            <RowResumeText title={t('stack_method')} value={getStackMethodById(item.stackMethod)?.name}/>
                        </div>
                    }

                    {/* Global policies do not set these values here; they come from the payroll policy configuration. */}
                    { isGlobal && (item.conflictResolution || item.stackMethod) &&
                        <div className="col-12 px-1">
                            <CustomChip
                                className={'chip-label-wrap'}
                                background={colors.secondary100}
                                fontColor={colors.secondary700}
                                borderColor={colors.secondary150}
                                legend={t('inherited_from_payroll_policy_configuration')}
                            />
                        </div>
                    }
                </div>
            </SummaryContainer>

            <DividerWithText title={t('rules')} />
            <SummaryContainer>
                <RulesTable rules={item.rules} isGlobal={isGlobal} />
            </SummaryContainer>
        </>
    );
};

export default PolicySummary;
